import React, { useState } from 'react';
import '../css/HamburgerMenu.css';

const HamburgerMenu = ({
  setCurrentScreen,
  toggleViewMode,
  viewMode,
  handleShowResume,
  handleShowResults,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleMenuClick = (screen) => {
    setCurrentScreen(screen);
    setIsOpen(false); // Close menu after selecting an option
  };

  return (
    <div className="hamburger-menu">
      <button
        className="hamburger-icon"
        onClick={toggleMenu}
        aria-label={isOpen ? 'Close menu' : 'Open menu'}
      >
        &#9776;
      </button>
      {isOpen && (
        <>
          <div className="overlay" onClick={toggleMenu}></div>
<div className="menu-items">
  <button type="button" onClick={() => handleMenuClick('home')}>Home</button>
  <button type="button" onClick={() => handleMenuClick('form')}>Form</button>
  <button type="button" onClick={() => handleMenuClick('inspector')}>One-Shot Preflight</button>
  <button type="button" onClick={() => handleMenuClick('tailorResume')}>Tailor Resume</button>
  <button type="button" onClick={() => handleMenuClick('oneShotResume')}>One-Shot Resume</button>
    <button type="button" onClick={() => handleMenuClick('info')}>Tips and Strategies</button>
</div>

        </>
      )}
    </div>
  );
};

export default HamburgerMenu;
